const translations = {
    deleteInvitationErrorMessage: 'Error deleting invitation',
    deleteInvitationSuccessMessage: 'Invitation deleted successfully',
    fetchInvitationsErrorMessage: 'Error fetching invitations',
    inviteUserToOrganizationErrorMessage: 'Error inviting user to organization',
    inviteUserToOrganizationSuccessMessage: 'User Invite Sent'
};

export default translations;
